module.exports = __webpack_public_path__ + "img/menu-personal-white.acb240aa.svg";